module.exports = __webpack_public_path__ + "assets/img/lp-report-1.1e0d39ae.svg";